import { render, staticRenderFns } from "./penaltyManage.vue?vue&type=template&id=017a7540"
import script from "./penaltyManage.vue?vue&type=script&lang=js"
export * from "./penaltyManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017a7540')) {
      api.createRecord('017a7540', component.options)
    } else {
      api.reload('017a7540', component.options)
    }
    module.hot.accept("./penaltyManage.vue?vue&type=template&id=017a7540", function () {
      api.rerender('017a7540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/penalty/penaltyManage.vue"
export default component.exports